import{isNotBrowser as a}from"../../constants/isNotBrowser.js";var o=function(o){a||(window.dataLayer=window.dataLayer||[],(null==o?void 0:o.ecommerce)&&window.dataLayer.push({ecommerce:null}),window.dataLayer.push(o))};export{o as pushDataLayer};
//# sourceMappingURL=index.js.map
